import React from "react";
import SearchByUserAndDate from "../../components/common/SearchByUserAndDate";
import "../../styles/css/Contacts.css";
import Axios from "axios";
import * as Constants from "../../consts/Constants.js";
import MapContacts from "./MapContacts";
import Paper from "@material-ui/core/Paper";
import ContactList from "./ContactList";

const Contacts = () => {
  const [state, setState] = React.useState({
    mapData: [],
    contactData: [],
  });

  const onSearch = (userId, date) => {
    Axios.get(
      Constants.FINAL_URL_TRACE_CONTACT_USER_DATE + "/" + userId + "/" + date
    ).then((response) => {
      let data = response.data;
      setState({ ...state, contactData: data });
      console.log(data);
    });
  };

  const setMapData = (mapData) => {
    setState({ ...state, mapData: mapData });
  };

  return (
    <div className="contacts">
      <Paper className="searchContacts">
        <SearchByUserAndDate
          title="Buscar contactos"
          onSearch={onSearch}
          horizontal={true}
        />
      </Paper>
      <ContactList data={state.contactData} setMapData={setMapData} />
      <MapContacts data={state.mapData} />
    </div>
  );
};

export default Contacts;
